module.exports = __webpack_public_path__ + "img/audio.d0a96c7d.jpg";